/* Copyright (c) 2019-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BridgeCommands } from 'bridge-commands/bridge.commands';
import { LoggingService } from '../logging/logging.service';
import { BridgeMockService } from './bridge.mocks.service';
import { FullBridgeCommand } from './bridge.service';
import { BrowserPluginManager } from './browser-plugin/browser-plugin-manager.service';
import { PluginService } from './plugin.service';

@Injectable()
export class BrowserService extends PluginService {
    constructor(
        loggingService: LoggingService,
        browserPluginManager: BrowserPluginManager,
        bridgeMocks?: BridgeMockService
    ) {
        super(loggingService.getLogger('crimson/browser'), browserPluginManager, undefined, bridgeMocks);
    }

    executeCommandInternal<ParamType extends object, ResponseType>(
        command: BridgeCommands.Command<ParamType, ResponseType>,
        params: ParamType,
        shouldLogPayload: boolean,
        shouldIncludePayloadInError: boolean
    ): Observable<ResponseType> {
        const fullBridgeCommand: FullBridgeCommand<ParamType> = this.makeFullBridgeCommand(
            command,
            params,
            command.legacyCommand !== PluginService.EXTENSION_MESSAGE
        );

        if (this.handlerMap.has(fullBridgeCommand.module)) {
            return this.executeCommandUsingPlugin(command, params, shouldLogPayload, shouldIncludePayloadInError);
        } else {
            this.logger.info(
                'Command not found',
                JSON.stringify(shouldLogPayload ? fullBridgeCommand : fullBridgeCommand.command)
            );
            return of(null);
        }
    }
}
